import { Popover, Space } from 'antd-mobile-v5'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import Tag from '../../components/common/Tag'
import { isAllFreeFirstCardCerts, notAvailable } from './cardOptionUtils'
import LoadingStatus from '../../components/FormTools/Loading'
import { getEcards, getProfile, getRedeemedFreeCards } from '../../reducers/selectors'
import { UClick } from '../../components/common/utils'
import styles from './BuyOptions.module.css'

export default function BuyOptions({
  mode,
  selectedImage,
  isPlastic,
  setIsPlastic = () => {},
  shopCartLoading,
  setSelectedCerts = () => {},
  selectedCerts,
  singleCert,
  hasChanghuanRights,
  previewOnly,
}) {
  const { ecards, profile, redeemedFreeCards } = useSelector((state) => ({
    profile: getProfile(state),
    ecards: getEcards(state),
    redeemedFreeCards: getRedeemedFreeCards(state),
  }))
  const { formatMessage } = useIntl()

  // 免费首卡（CHNA-2618）：服务端按已选证书的 cardRequestType 对普通版自动归零、实付仅运费。
  // 按已选证书逐张判定（资格是证书维度的），全部是 CARD_REQUEST 才展示免费文案，
  // 避免补卡/混合选择被标成免费（实际按 99 元收费）；
  // 已下单/已兑证书（redeemedFreeCards）不再展示免费
  const showFreeFirstCardTag =
    isAllFreeFirstCardCerts(selectedCerts, ecards, redeemedFreeCards) && selectedImage.indexOf('普通版') >= 0

  useEffect(() => {
    UClick('buyCardsPage')
  }, [])

  const togglePlastic = (isPlastic) => {
    setSelectedCerts([])
    setIsPlastic(isPlastic)
  }

  const toggleCert = (ecard) => {
    const hasCurrentCert = selectedCerts.find((cert) => cert === ecard.encodedId)
    if (singleCert) {
      if (!hasCurrentCert) {
        setSelectedCerts([ecard.encodedId])
      } else {
        setSelectedCerts([])
      }
    } else {
      if (!hasCurrentCert) {
        setSelectedCerts([...selectedCerts, ecard.encodedId])
      } else {
        setSelectedCerts(selectedCerts.filter((c) => c !== ecard.encodedId))
      }
    }
  }

  const ecardsDisabled =
    selectedImage.indexOf('普通版') >= 0 ||
    selectedImage.indexOf('生肖卡') >= 0 ||
    hasChanghuanRights ||
    selectedImage.indexOf('周年') >= 0

  return (
    <div className={styles.container}>
      <div className={styles['card-types']}>
        <h4 className={styles.optionTitle}>选择卡片类型</h4>
        <div className={styles.types}>
          <Tag selected={!isPlastic} onClick={() => togglePlastic(false)} mode={mode} disabled={ecardsDisabled}>
            <span>电子卡1张</span>
            <span>￥50</span>
          </Tag>
          <Tag selected={isPlastic} onClick={() => togglePlastic(true)} mode={mode}>
            <div className={styles['tag-content']}>
              <span>实体+电子卡1套</span>
            </div>
            <span>{showFreeFirstCardTag ? formatMessage({ id: 'ecard-free-first-card-tag' }) : '￥99'}</span>
          </Tag>
        </div>
      </div>
      {!previewOnly && (
        <>
          <h4 className={styles.optionTitle}>
            选择证书
            {!singleCert && <span>（可多选）</span>}
          </h4>
          {shopCartLoading ? (
            <LoadingStatus color={'#29489E'} />
          ) : (
            <Space wrap block className={styles.ecards}>
              {(ecards || []).map((ecard, index) =>
                notAvailable(ecard, selectedImage, isPlastic, profile?.buyCred) ? (
                  <Popover
                    content={notAvailable(ecard, selectedImage, isPlastic, profile?.buyCred)}
                    trigger="click"
                    placement="top"
                    key={index}
                  >
                    <Tag disabled={true} mode={mode}>
                      {ecard.ecardName}
                    </Tag>
                  </Popover>
                ) : (
                  <Tag
                    key={index}
                    selected={!!selectedCerts.find((c) => c === ecard.encodedId)}
                    onClick={() => toggleCert(ecard)}
                    mode={mode}
                  >
                    {ecard.ecardName}
                  </Tag>
                )
              )}
            </Space>
          )}
        </>
      )}
    </div>
  )
}
